import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import {
    Context
} from 'shared/context/GlobalState';
import {
    OrganizationContext
} from 'shared/context/OrganizationContext';
import React, {
    useContext, useEffect, useState
} from 'react';
import {
    Outlet, useNavigate, useParams
} from 'react-router-dom';

export const ProtectedOrgRoute = () => {

    const [loading, setLoading] = useState(true);

    const {
        organizations, addNewNotifcation
    } = useContext(Context);
    const {
        actions
    } = useContext(OrganizationContext);
    const {
        oragID
    } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const isMember = organizations?.find((i) => i._id === oragID);
        if (isMember) {
            if (isMember.clusterStatus === 'DEPLOYED') {
                actions({
                    type: 'SET_SELECTED_ORGANIZATION',
                    payload: (prev => ({
                        subOrganizations: prev?.subOrganizations || [],
                        byoKeys: prev?.byoKeys || [],
                        ...isMember
                    }))
                });
                localStorage.setItem('selectedOrganization', isMember._id);
            } else {
                navigate('/organizations');
                addNewNotifcation('Organization not deployed yet', 'warning');
            }
        } else {
            navigate('/organizations');
            addNewNotifcation('You are not member of this organization', 'warning');
        }

        setLoading(false);

        return () => {
            actions({
                type: 'SET_SELECTED_ORGANIZATION',
                payload: null
            });
        };
    }, [oragID]);

    if (loading) {
        return <div className='flex flex-grow flex-col justify-center items-center'> <AppLoader size={50} /> </div>;
    }

    return (
        <Outlet />
    );
};
